import {fetchBody, URL_CUSTOMERPOSITION_GET_LIST, URL_CUSTOMERPOSITION_ADD, URL_CUSTOMERPOSITION_GET_DETAIL, URL_POSITIONDEMAND_GET_LIST, URL_POSITIONDEMAND_GET_DETAIL} from "../config"
import { toLogout, cleanFetch } from "./apiTools";
import { getToken } from "../component/Login/Auth";

export function api_getPositionDemandList ({mReqPositionDemandList, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqPositionDemandList, token}), 
      url: URL_POSITIONDEMAND_GET_LIST, 
      success,
      failure
    })
  }
}

export function api_addCustomerPosition ({mRespCustomerPosition, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mRespCustomerPosition, token}), 
      url: URL_CUSTOMERPOSITION_ADD, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_getPositionDemandDetail ({mReqCustomerPositionDetail, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqCustomerPositionDetail, token}), 
      url: URL_POSITIONDEMAND_GET_DETAIL, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}
